module.exports = __webpack_public_path__ + "img/jllk.cdb0de42.jpg";